import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { UnpivotPlainObject } from '../plainObjects/unpivot.plainObject';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class UnpivotVisitor extends BaseTransformationVisitor {
    private get _unpivotTransformation(): UnpivotPlainObject {
        return this.transformation as UnpivotPlainObject;
    }

    public visitOutputDefinition(outputDefinitionContext: any): void {
        const unpivotedColums = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
        this._unpivotTransformation.unpivotKeyColumn = unpivotedColums.splice(0, 1)[0];
        this._unpivotTransformation.unpivotedColumns = unpivotedColums;
    }

    public visitBasicFunction(context: any): void {
        if (context.basicName().getText() === 'ungroupBy') {
            MatchFunctionUtil.addGroupByColumns(this._unpivotTransformation, context);
        }
    }

    public visitMetaFunctionExpr(context: any): void {
        if (context.metafunction().basicName().getText() === 'ungroupBy') {
            MatchFunctionUtil.addGroupByColumns(this._unpivotTransformation, context.metafunction());
        }
    }

    public visitConfiguration(context: any): void {
        const configName: string = this._getText(context.configName());
        if (configName === 'lateral') {
            this._unpivotTransformation.lateralColumnArrangement = this._getText(context.expression()) === 'true';
        }
        if (configName === 'ignoreNullPivots') {
            this._unpivotTransformation.dropNullRows = this._getText(context.expression()) === 'true';
        }
        if (configName === 'pivotValues' && context.expression) {
            MatchFunctionUtil.addPivotValues(this._unpivotTransformation, context.expression());
        }
    }
}
